import { render, staticRenderFns } from "./ActeJument.vue?vue&type=template&id=75bb50ba&"
import script from "./ActeJument.vue?vue&type=script&lang=js&"
export * from "./ActeJument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports